<div class="bg-card rounded-2xl border border-border overflow-hidden">
  <h3 class="text-[17px] font-bold text-foreground px-4 pt-3.5 pb-2">Who to Follow</h3>
  <div>
    <div *ngFor="let user of users" class="flex items-center gap-3 px-4 py-2.5 hover:bg-secondary/50 transition-colors cursor-pointer">
      <div class="w-9 h-9 rounded-full overflow-hidden bg-muted flex-shrink-0">
        <img [src]="user.avatarUrl" alt="" class="w-full h-full object-cover" />
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-[14px] font-semibold text-foreground truncate leading-tight">{{ user.name }}</p>
        <p class="text-[13px] text-muted-foreground truncate leading-tight">&#64;{{ user.handle }}</p>
      </div>
      <button type="button" class="h-8 px-4 rounded-full bg-foreground text-background text-[13px] font-bold hover:opacity-90 transition-opacity flex-shrink-0">
        Follow
      </button>
    </div>
  </div>
  <button type="button" class="w-full px-4 py-3 text-[14px] text-ts-blue hover:bg-secondary/50 transition-colors text-left">
    Show more
  </button>
</div>
